import { callApi } from '@local_modules/generic/fetch'

export default class RecommendedActions {
  constructor (params) {
    console.log('RecommendedActions constructor')
    this.budgetModule = params.budgetModule
    this.containerId = params.containerId

    this.render()
  }

  render () {
    console.log('RecommendedActions render')

    if (!this.budgetModule?.data?.budget || !this.budgetModule?.data?.ledgerAccounts) {
      renderMissingDataGuidance(this)
    } else {
      renderActions(this)
    }
  }
}

function renderMissingDataGuidance (instance) {
  const containerElement = document.getElementById(instance.containerId)

  if (!instance.budgetModule?.data?.budget) {
    containerElement.innerHTML = 'Please upload a budget file'
  } else if (!instance.budgetModule?.data?.ledgerAccounts) {
    containerElement.innerHTML = 'Please pick an entity'
  }
}

function renderActions (instance) {
  console.log('renderActions', instance)

  const containerElement = document.getElementById(instance.containerId)

  const numberAccountsInBudget = instance.budgetModule?.data?.budgetAccountsWithLedgerAccounts.filter(oneRow => oneRow.budget?.totalAmount).length
  const numberAccountsInBudgetInXero = instance.budgetModule?.data?.budgetAccountsWithLedgerAccounts.filter(oneRow => oneRow.budget?.totalAmount && oneRow.ledgerAccount).length
  const accountsMissingInXero = instance.budgetModule?.data?.budgetAccountsWithLedgerAccounts.filter(oneRow => oneRow.budget?.totalAmount && !oneRow.ledgerAccount).length

  containerElement.innerHTML = htmlTemplate
    .replace('{numberAccountsInBudget}', numberAccountsInBudget)
    .replace('{numberAccountsInBudgetInXero}', numberAccountsInBudgetInXero)
    .replace('{createAccountsInXeroButton}', (accountsMissingInXero > 0) ? `<wp-button id="createAccountsInXeroButton">Create the ${accountsMissingInXero} missing Accounts in Xero</wp-button>` : '')

  containerElement.querySelector('#createAccountsInXeroButton')?.addEventListener('click', function (event) {
    createAccountsInXero(instance)
  })
}

const htmlTemplate = `
  <wp-container>
    <div>Budget has {numberAccountsInBudget} accounts, of which {numberAccountsInBudgetInXero} are in Xero</div>
    {createAccountsInXeroButton}
  </wp-container>
`

async function createAccountsInXero (instance) {
  console.log('createAccountsInXero', instance)
  const createAccountsInXeroButton = document.getElementById(instance.containerId)?.querySelector('#createAccountsInXeroButton')
  if (!createAccountsInXeroButton) return

  createAccountsInXeroButton.setAttribute('data-loading', true)

  const accountsMissingInXero = instance.budgetModule?.data?.budgetAccountsWithLedgerAccounts.filter(oneRow => oneRow.budget?.totalAmount && !oneRow.ledgerAccount)

  const accountsToCreateInXero = accountsMissingInXero.map(oneAccountRow => {
    return {
      code: oneAccountRow.budget?.ledgerAccountInfo?.code,
      name: oneAccountRow.budget?.ledgerAccountInfo?.name
    }
  })

  await callApi('/api/xero-api/create-accounts', null, {
    body: {
      accountingOrganisationId: instance.budgetModule.accountingOrganisationId,
      accounts: accountsToCreateInXero
    },
    method: 'POST'
  }
  )

  createAccountsInXeroButton.removeAttribute('data-loading')
}
